const languages = ["Javascript", "C#"];

const frontEnd = [
  "React",
  "Next.js",
  "Vue.js",
  "React Native",
  "Tailwind CSS",
  "SCSS",
];

const backEnd = ["Node", "Express", "MYSQL", "MongoDB"];

const tools = [
  "VS Code",
  "Visual Studio",
  "Git / Github",
  "Powershell",
  "Bash"
];

const multimedia = [
  "Photoshop",
  "Illustrator",
  "Premiere",
  "After Effects",
  "Maya"
];

const otherSkills = ["Jest", "Babel", "Webpack", "NPM"];

export default {
  languages,
  frontEnd,
  backEnd,
  tools,
  multimedia,
  otherSkills
};
